var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditJaune(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 401 401",
    style: {
      enableBackground: "new 0 0 401 401"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0AB00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.1,251.9c-5.5,0-10,4.5-10,10v88.7c0,16.5-13.4,29.9-30,30H49.9c-16.5,0-29.9-13.4-30-30V90.3 c0-16.5,13.4-29.9,30-30h88.7c5.5,0,10-4.5,10-10c0-5.5-4.5-10-10-10H49.9C22.4,40.4,0,62.7,0,90.3v260.3 c0,27.6,22.4,49.9,49.9,49.9h280.2c27.6,0,49.9-22.4,49.9-49.9v-88.7C380.1,256.4,375.6,251.9,370.1,251.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.1,14.7c-17.6-17.6-46-17.6-63.6,0L134.4,192.9c-1.2,1.2-2.1,2.7-2.6,4.4l-23.4,84.6c-1,3.5,0,7.2,2.6,9.7 c2.5,2.5,6.3,3.5,9.7,2.6l84.6-23.4c1.7-0.5,3.2-1.3,4.4-2.6L387.9,90c17.5-17.6,17.5-46,0-63.6L376.1,14.7z M156.2,199.3L302,53.5 l47,47L203.2,246.4L156.2,199.3z M146.8,218.2l37.6,37.6l-52,14.4L146.8,218.2z M373.7,75.8l-10.6,10.6l-47-47l10.6-10.6 c9.7-9.7,25.6-9.7,35.3,0l11.7,11.7C383.5,50.3,383.5,66.1,373.7,75.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditJaune);
export default __webpack_public_path__ + "static/media/edit_JAUNE.368c5df9f2ac382e19f7224ddde52c43.svg";
export { ForwardRef as ReactComponent };